export default __webpack_public_path__ + "static/media/30.278d005e.jpg";